<template>
	<v-container fluid class="ma-0 pa-0">
    <Header title="New Thumbnail Test" />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-5 mt-8 mb-7" cols="12" id="cctv_player_box">
				<v-row class="ma-0 pa-0" align="center">
					<v-col class="ma-0 pa-2" cols="4" align="center"
						:class="{'non_display': streamingUrlList[0] == undefined || streamingUrlLoading }">
						<v-col id="thumbnail_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;">
							<img id='thumbnail_img0' style="height:100%;width:100%;" class="ma-0 pa-0"
								@load="onLoad(0)" />
							<v-skeleton-loader id="img_skeleton" width='100%' height='13rem' :boilerplate="false" elevation="0" dark  type="image"
								v-if="imgLoaders[0] == true"></v-skeleton-loader>
							<v-col class="ma-0 pa-0 pl-2" cols="12" id="thumbnail_title_box" align="left"
								v-if="streamingUrlLoading == false">
								{{ '国分寺店 外' }}
							</v-col>
						</v-col>
					</v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"
						:class="{'non_display': streamingUrlList[1] == undefined || streamingUrlLoading }">
						<v-col id="thumbnail_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;">
							<img id='thumbnail_img1' style="height:100%;width:100%;" class="ma-0 pa-0" @load="onLoad(1)" />
							<v-col class="ma-0 pa-0 pl-2" cols="12" id="thumbnail_title_box" align="left"
								v-if="streamingUrlLoading == false">
								{{ '国分寺店 外' }}
							</v-col>
							<v-skeleton-loader id="img_skeleton" width='100%' height='13rem' :boilerplate="false" elevation="0" dark  type="image"
								v-if="imgLoaders[1] == true"></v-skeleton-loader>
						</v-col>
					</v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"
						:class="{'non_display': streamingUrlList[2] == undefined || streamingUrlLoading }">
						<v-col id="thumbnail_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;">
							<img id='thumbnail_img2' style="height:100%;width:100%;" class="ma-0 pa-0" @load="onLoad(2)" />
							<v-col class="ma-0 pa-0 pl-2" cols="12" id="thumbnail_title_box" align="left"
								v-if="streamingUrlLoading == false">
								{{ '国分寺店 外' }}
							</v-col>
							<v-skeleton-loader id="img_skeleton" width='100%' height='13rem' :boilerplate="false" elevation="0" dark  type="image"
								v-if="imgLoaders[2] == true"></v-skeleton-loader>
						</v-col>
					</v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"
						:class="{'non_display': streamingUrlList[3] == undefined || streamingUrlLoading }">
						<v-col id="thumbnail_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;">
							<img id='thumbnail_img3' style="height:100%;width:100%;" class="ma-0 pa-0" />
							<v-col class="ma-0 pa-0 pl-2" cols="12" id="thumbnail_title_box" align="left"
								v-if="streamingUrlLoading == false">
								{{ '国分寺店 外' }}
							</v-col>
						</v-col>
					</v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"
						:class="{'non_display': streamingUrlList[4] == undefined || streamingUrlLoading }">
						<v-col id="thumbnail_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;">
							<img id='thumbnail_img4' style="height:100%;width:100%;" class="ma-0 pa-0" />
							<v-col class="ma-0 pa-0 pl-2" cols="12" id="thumbnail_title_box" align="left"
								v-if="streamingUrlLoading == false">
								{{ '国分寺店 外' }}
							</v-col>
						</v-col>
					</v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"
						:class="{'non_display': streamingUrlList[5] == undefined || streamingUrlLoading }">
						<v-col id="thumbnail_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;">
							<img id='thumbnail_img5' style="height:100%;width:100%;" class="ma-0 pa-0" />
							<v-col class="ma-0 pa-0 pl-2" cols="12" id="thumbnail_title_box" align="left"
								v-if="streamingUrlLoading == false">
								{{ '国分寺店 外' }}
							</v-col>
						</v-col>
					</v-col>
				</v-row>
				<template v-if="streamingUrlLoading">
					<ImageSkeleton :loaderCount="9" width='100%' height='10rem' />
				</template>
				<v-row class="ma-0 pa-0" align="center" style="display:none;">
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${0}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${1}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${2}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${3}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${4}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${5}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
				</v-row>

				<!-- <v-row class="ma-0 pa-0" align="center">
					<v-col class="ma-0 pa-2" cols="4" align="center"
						v-for="item in 6" :key="item">
						<v-col id="thumbnail_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;">
							<v-img :ref="`thumbnail_img${item}`" src="test" max-height="13rem" max-width="100%" class="ma-0 pa-0"></v-img>
							<v-col class="ma-0 pa-0 pl-2" cols="12" id="thumbnail_title_box" align="left">
								{{ '国分寺店 外' }}
							</v-col>
						</v-col>
					</v-col>
				</v-row>
				<v-row class="ma-0 pa-0" align="center" style="display:none;">
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${0}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${1}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
					<v-col class="ma-0 pa-2" cols="4" align="center"><video :ref="`dash-video${2}`" :width="'300'" height=250 style="display:none;" class="video-js"></video></v-col>
				</v-row> -->

			</v-col>

			<!-- <video :ref="`dash-video${0}`" width=800 height=500 controls
			  class="video-js vjs-default-skin vjs-big-play-centered vjs-current-time vjs-control-bar">
			</video>
			<v-col class="ma-0 pa-3" cols="12" align="left">
				<img :ref="`thumbnail_img${0}`" />
			</v-col> -->
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import 'dashjs';
import 'videojs-contrib-dash';
import ImageSkeleton from '@/components/loader/ImageSkeleton.vue';
import Header from './components/Header.vue';

export default {
	components: {
		ImageSkeleton, Header
	},
	mixins: [mixin.common],
	data: () => ({
		player: null,
		players: [],
		playerOptions: {
			autoplay: 'muted',
		},
		streamList: [],
    activeStreamList: [],
		streamingUrlList: [],
		streamingUrlLoading: false,
		streamingCount: 0,
		thumbnailImageList: [],
		imgLoaders: [],
		makingThumbnail: true,
    imgList: [],
	}),
	watch: {
		makingThumbnail: function(item) {
			if(item == false) {
				setTimeout(() => {
					if(this.players.length != 0) {
						for(var i = 0; i < this.players.length; i++) {
							console.log('pause, dispose');
							let video = this.$refs[`dash-video${i}`];
							this.players[i].pause();
							this.players[i].dispose();

							const stream = video.srcObject;
							// const tracks = stream.getTracks();

							// tracks.forEach(function(track) {
							// 	track.stop();
							// });

							video.srcObject = null;
						}
					}
				}, 10000);
			}
		},
	},
	created() {
		for(var i = 0; i < 12; i++) {
			this.imgLoaders.push(true)
		}
	},
	mounted() {
		// this.fetchVideo();
		this.getCameraList();
		console.log(this.imgLoaders[0]);
    // AWS.config.region = 'ap-southeast-1'; // Region
    // AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    //   IdentityPoolId: 'ap-southeast-1:c555a718-3032-4135-bad7-5e3d888c860',
    //   RoleArn: 'arn:aws:iam::509004160589:role/Cognito_UeyesStgPoolUnauth_Role'
    // });
	},
	// beforeDestroy() {
  //   if(this.player) {
  //     this.player.dispose();
  //   }
	// 	if(this.players.length != 0) {
	// 		for(var i = 0; i < this.players.length -1; i++) {
  //     	this.players[i].dispose();
  //     }
	// 	}
  // },
	methods: {
		async getCameraList() {
			this.streamingUrlLoading = true;
			let params = {};
			await this.networkController.getDashboardCameraList(params)
			.then(async (res) => {
				console.log('%cDashboard Camera List\n', "color:#008DD0;", res.data);
				this.streamList = res.data;
				this.streamList.forEach((item, index) => {
					this.getStreamingUrl(item.streamName, index);
				});
			}).catch(error => {
				
			});
		},
		async getStreamingUrl(streamName, index) {
      this.activeStreamList = [];
			let params = {};
			await this.networkController.getDashStreamingUrl(params, streamName,'' , '').then(async (res) => {
				console.log('%cStreaming URL\n', "color:#008DD0;",res.data);
				this.streamingUrlList.push(res.data.dashstreamingSessionURL);
        this.activeStreamList.push(streamName);
				this.createPlayer(res.data.dashstreamingSessionURL, this.streamingCount);
				if(index == this.streamList.length - 1) {
					this.streamingUrlLoading = false;
					this.makingThumbnail = false;
				}
			}).catch(error => {
				if(index == this.streamList.length - 1) {
					this.streamingUrlLoading = false;
					this.makingThumbnail = false;
				}
			});
		},
		createPlayer(videoSourceUrl, streamingCount) {
			console.log(streamingCount);
			this.streamingCount = this.streamingCount + 1;
			this.players[streamingCount] = videojs(this.$refs[`dash-video${streamingCount}`], this.playerOptions, function onPlayerReady() {
				this.src({
					src: `${videoSourceUrl}`,
					type: 'application/dash+xml'
				});
			});
			this.buildVideoPlayer(streamingCount);
		},
		onLoad(index) {
			console.log(index);
			this.imgLoaders.splice(index, 1, false);
		},

		fetchVideo() {
			this.players[0] = videojs(this.$refs[`dash-video${0}`], this.playerOptions, function onPlayerReady() {
				this.src({
					// src: 'https://s3.amazonaws.com/_bc_dml/example-content/sintel_dash/sintel_vod.mpd',
					src: "https://b-a0b51971.kinesisvideo.us-east-1.amazonaws.com/dash/v1/getDASHManifest.mpd?SessionToken=CiByZDQhk7g4IfPC--Q4aj1OzMCWFRa4HsJo425_sBSqiRIQFVq4cFzqBt0fmZ5NGcPcjhoZORs9FsjWlpeBA9ySVMr0EXf5TwBQUXTaEyIgUqs9stpJ2zckg670S4y2_RM0aK8knIKZWXWtmFbOsK4~",
					type: 'application/dash+xml'
				});
			});
			this.buildVideoPlayer(0);
		},
		buildVideoPlayer(streamingCount) {
			let player = this.players[streamingCount];
			// let player = this.player;
			let vm = this;
			let video = this.$refs[`dash-video${streamingCount}`];
			// let img = this.$refs[`thumbnail_img${streamingCount}`];
			let img = document.querySelector(`#thumbnail_img${streamingCount}`);

			this.players[streamingCount].one("loadedmetadata", async () => {
				let duration = this.players[streamingCount].duration();
				console.log(`Duration of Video ${Math.floor(duration)}s`);
				console.log(`Original Width of Video ${this.players[streamingCount].videoWidth()}`);
				// player.currentTime(0);

				// setTimeout(() => {
				// 	this.players[streamingCount].pause();
				// }, 8000);
			});

			video.addEventListener('loadeddata', async () => {
				setTimeout(() => {
					// const thumbUrl = this.createThumb(video, 300, 200);
					// img.src = thumbUrl;
          this.getThumb(this.activeStreamList[streamingCount], streamingCount);
				}, 2000);
			});
		},
		createThumb(video, w, h) {
			let c = document.createElement("canvas"),    // create a canvas
				ctx = c.getContext("2d"),                // get context
				img = new Image();                       // final image
			c.width = w;                                 // set size = thumb
			c.height = h;
			ctx.drawImage(video, 0, 0, w, h);            // draw in frame
			return c.toDataURL();                     // convert canvas to URL
		},
    async getThumb(streamName, index) {
			this.imgList = await this.networkController.awsGetThumbnail(streamName);
			//imgList data값 2개, imgList[0]은 Null값
      document.querySelector(`#thumbnail_img${index}`).src = 'data:image/png;base64,' + this.imgList[1].ImageContent;
    },
	}
}
</script>

<style lang="scss" scoped>
#cctv_player_box {
	background-color: #34363C;
	// border: 1px solid #707070;
	color: white;
	border-radius: 5px;
	min-height: 10rem;
}
#thumbnail_box {
	position: relative;
	height: 13rem;
}
#thumbnail_title_box {
	position: absolute;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.75);
	color: #BEBEBE;
	font-size: 0.8rem;
}
.non_display {
	display: none;
}
#img_skeleton {
	position: absolute;
	top: 0;
}
</style>